import React from 'react';

import PropTypes from 'prop-types';
import { FlexGrid, Link, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import CategoryGroup from './components/categoryGroup';

const SOF2_URL = 'https://www.mysalesorders.com/en-US/login';

const Dashboard = ({ categories, locale, history }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    DASHBOARD: {
      dashboardHeadingTitle,
      dashboardNotePrefix,
      dashboardNoteLinkLabel,
      dashboardNoteSuffix
    }
  } = localizedStrings;

  return (
    <FlexGrid>
      <FlexGrid.Row>
        <FlexGrid.Col>
          <Typography heading="h1" variant={{ size: 'h1' }} block>{dashboardHeadingTitle}</Typography>
          <div style={{ paddingBottom: '1.5rem' }}>
            <Typography variant={{ size: 'body' }} block>
              {dashboardNotePrefix}
              <Link href={SOF2_URL} hrefAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}>
                {dashboardNoteLinkLabel}
              </Link>
              {dashboardNoteSuffix}
            </Typography>
          </div>
        </FlexGrid.Col>
      </FlexGrid.Row>
      {categories.map(category => (
        <CategoryGroup category={category} locale={locale} history={history} />
      ))}
    </FlexGrid>
  );
};

Dashboard.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({})
    })
  ).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default Dashboard;
